/** @jsxImportSource @emotion/react */
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'hooks/useMessageBar';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import { tb } from 'components/layouts/Table';
import useSessionStore from 'stores/useSessionStore';
import _ from 'lodash';
import { useCommonModal } from 'hooks/useCommonModal';
import { DefaultProps } from 'pages/md/invest/MdIvesCmpuRegPage';

const DtlIsptMatr = ({ elmPrjId }: DefaultProps) => {
  const { t } = useTranslation();
  const { isLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const { openCommonModal } = useCommonModal();

  const [rowData, setRowData] = useState([]);

  const layoutDefinition = [
    { title: t('setup.label.적용여부', '적용여부'), width: '100' },
    { title: t('setup.label.공정', '공정'), width: '' },
    { title: t('setup.label.설비군', '설비군'), width: '' },
    { title: t('setup.label.점검대상', '점검대상'), width: '' },
    { title: t('setup.label.점검항목', '점검항목'), width: '' },
    { title: t('setup.label.구분', '구분'), width: '' },
  ];

  const initCodes = () => {
    //
  };

  const btnAdd = () => {
    //
  };

  const btnDel = () => {
    //
  };

  useEffect(() => {
    initCodes();
  }, []);

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.상세 점검사항', '상세 점검사항')}</h3>
        </SubTitleGroup>
        <GlobalBtnGroup>
          <Button css={IconButton.button} className="icoNone ok" onClick={btnAdd}>
            {t('com.label.상세 점검사항 추가', '상세 점검사항 추가')}
          </Button>
          <Button css={IconButton.button} className="delRow" onClick={btnDel}>
            {t('com.label.행삭제', '행삭제')}
          </Button>
          <Button
            css={IconButton.button}
            className="save"
            disabled={isLoading}
            onClick={(e) => null}
          >
            {t('com.label.저장', '저장')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <TableContainer css={tb.tableCol}>
        <Table>
          <TableHead>
            <TableRow>
              {layoutDefinition.map((item, idx) => {
                return (
                  <TableCell key={idx} width={item.width}>
                    {item.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.map((item, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}
            {rowData.length === 0 && (
              <TableRow>
                <TableCell colSpan={layoutDefinition.length}>
                  조회 가능한 데이터가 없습니다.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DtlIsptMatr;
